import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { IPrioritySchedulerColumnProps } from "../PrioritySchedulerBoard.types";

export function PrioritySchedulerColumn({
  EventComponent,
  events = [],
  hourHeight,
  dayStartTime,
  onEventRemove,
  onCardClick,
}: Readonly<IPrioritySchedulerColumnProps>) {
  const [hours, minutes] = dayStartTime?.split(":").map(Number) ?? [0, 0];
  const hoursToDayStartTime = hours + (minutes ?? 0) / 60;
  const topPosition = hourHeight ? hoursToDayStartTime * hourHeight : 0;

  const { classes } = useStyles({ topPosition });
  return (
    <Box className={classes.columnContainer}>
      <Box className={classes.cardContainer}>
        {events.map((event) => {
          const durationHeight = event.expectedDuration
            ? (event.expectedDuration / 60) * hourHeight
            : hourHeight;
          return (
            <Box key={event.id} height={durationHeight}>
              {EventComponent && (
                <EventComponent
                  attempt={event}
                  onCardClick={onCardClick}
                  onEventRemove={
                    onEventRemove ? () => onEventRemove(event.id) : undefined
                  }
                  isRemovable={!event.assignedUserId}
                />
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

const useStyles = makeStyles<{ topPosition: number }>()(
  (theme, { topPosition }) => ({
    columnContainer: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: theme.palette.info.light,
      padding: theme.spacing(0, 1),
      height: "100%",
      width: "100%",
      borderBottomRightRadius: theme.spacing(1),
      borderBottomLeftRadius: theme.spacing(1),
    },
    cardContainer: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(0.5),
      flex: 1,
      position: "absolute",
      top: topPosition,
    },
  })
);
